import client from "../config/AxiosConfig";

export const CheckContactConfirmation = async () =>
  client.get("/contactConfirmation");

export const UpdateContactConfirmation = async (data) =>
  client.put("/contactConfirmation", data);
